// extracted by mini-css-extract-plugin
module.exports = {"Style":"_3Dj890k5YHxERJ-4S9BHlG"};